import axios from '@/libs/api.request'

export const getBomScrap = (bomId) => {
  return axios.request({
    url: `/quality-data/scrap/bom/${bomId}`,
    method: 'get'
  })
}

export const setBomScrap = (bomId, data) => {
  return axios.request({
    url: `/quality-data/scrap/bom/${bomId}`,
    method: 'post',
    data
  })
}

export const setPartScrap = (partId, data) => {
  return axios.request({
    url: `/quality-data/scrap/part/${partId}`,
    method: 'post',
    data
  })
}

export const getPartScraps = (manufacturerPartIds) => {
  return axios.request({
    url: `/quality-data/scrap/part`,
    method: 'get',
    params: { manufacturerPartIds }
  })
}

export const getQualityDataList = (modelType, data) => {
  return axios.request({
    url: `/search/${modelType}`,
    method: 'post',
    data
  })
}

export const updateDefaultScrap = (bomId) => {
  return axios.request({
    url: `/quality-data/scrap/bom/default-scrap/${bomId}`,
    method: 'post'
  })
}
